import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { DashboardStore } from 'src/app/shared/_services/store';
import { HomePageService } from '../homepage.service';
declare const window: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit, DoCheck {
  web: string;
  formUrl: string;
  cloudinary: string;
  year: any;
  public YT: any;
  public videoUrl: any;
  public player: any;
  public event: any;
  public reframed = false;
  public played = false;
  loading: boolean;
  loading2: boolean;
  pauseVideoHideModal: any;
  toggleVideo: () => void;
  closeModal: (e: any) => void;

  constructor(
    private router: Router,
    private platform: Platform,
    private dashboardStore: DashboardStore,
    private homePageService: HomePageService
  ) { }
  startVideo() {
    this.reframed = false;
    this.player = new window.YT.Player('player', {
      videoId: this.videoUrl,
      playerVars: {
        modestbranding: 1,
        controls: 1,
        disablekb: 1,
        rel: 0,
        showinfo: 0,
        fs: 0,
        playsinline: 1,
        origin: 'http://localhost:8100'
      },
      events: {
        onReady: this.onPlayerReady.bind(this),
      }
    });
  }

  onPlayerReady(event: any) {
    event.target.playVideo();
    this.event = event;
  }

  submitNewsletterForm() {
    this.homePageService.submitNewsletterForm();
  }

  submitContactForm() {
    this.homePageService.submitContactForm();
  }

  ionViewWillEnter() {
    document.title = 'Welcome | Bank3D';
  }

  ngOnInit() {
    if (!this.platform.is('cordova') && this.dashboardStore.getCurrentUser()) {
      this.router.navigateByUrl('/dashboard');
    }
    if (this.platform.is('cordova')) {
      this.router.navigateByUrl('/login');
    }

    this.web = this.homePageService.web;
    this.year = this.homePageService.year;
    this.formUrl = this.homePageService.formUrl;
    this.cloudinary = this.homePageService.cloudinary;
    this.homePageService.shared();

    const howVideo = document.getElementById('how-video');
    this.toggleVideo = () => {
      howVideo.classList.toggle('how-video-show');
      howVideo.style.top = '0';
      this.played = true;
      if (this.event !== undefined) {
        this.event.target.playVideo();
      }
      setTimeout(() => {
        this.played = false;
      }, 1000);
    };

    this.pauseVideoHideModal = () => {
      howVideo.style.top = '-100vh';
      this.event.target.pauseVideo();
    };

    window.addEventListener('keydown', (event: any) => {
      if (event.key === 'Escape') {
        this.pauseVideoHideModal();
      }
    });

    this.closeModal = window.onclick = (e: any) => {
      if (e.target === howVideo) {
        this.pauseVideoHideModal();
      }
    };

    // YouTube embedded video
    this.videoUrl = 'wEQYHO2ry1M';
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  ngDoCheck(): void {
    this.loading = this.homePageService.loading;
    this.loading2 = this.homePageService.loading2;
    if (this.played === true) {
      this.startVideo();
    }
  }
}
